import { Pipe, PipeTransform } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { TranslateService } from "@ngx-translate/core";

@Pipe({
  name: "disableComma",
})
export class DisableCommaPipe implements PipeTransform {
  constructor(
    private snackBar: MatSnackBar,
    private translate: TranslateService
  ) {}

  transform(value: string, ...args: unknown[]): unknown {
    if (!value || !(value.length > 0)) return "";

    if (value.includes(",")) {
      this.translate
        .get("USE_POINT_FOR_DECIMAL_STEP")
        .subscribe((text) => this.snackBar.open(text));
    }

    return value;
  }
}
